function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#FA6358",
  fillOpacity: 0.15,
  d: "M89.92 45c0 24.853-20.13 45-44.96 45C20.13 90 0 69.853 0 45S20.13 0 44.96 0c24.83 0 44.96 20.147 44.96 45z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#444",
  d: "M95.789 43.2H61.694c-2.772 0-5.095 2.25-5.095 5.1v5.475H44.31c-1.424 0-2.698.825-3.222 2.175l-2.023 4.8-2.998 7.05v12.225c0 1.95 1.574 3.6 3.597 3.6h.824v.225c0 4.425 3.597 8.1 8.093 8.1s8.093-3.6 8.093-8.1v-.225h21.955v.225c0 4.425 3.597 8.1 8.093 8.1s7.943-3.825 7.943-8.25v-.225h3.372c1.573 0 2.847-1.2 2.847-2.85V48.3c0-2.775-2.323-5.1-5.095-5.1zM44.685 57.825h11.914v8.25H41.238l3.447-8.25zm3.746 29.85c-2.173 0-3.971-1.8-3.971-3.975s1.798-3.975 3.971-3.975 3.972 1.8 3.972 3.975-1.799 3.975-3.972 3.975zm6.82-8.25a8.093 8.093 0 00-6.82-3.75 8.092 8.092 0 00-6.819 3.75h-1.498V70.2h16.485v9.15H55.25v.075zm31.396 8.25c-2.173 0-3.972-1.8-3.972-3.975s1.799-3.975 3.972-3.975 3.971 1.8 3.971 3.975-1.798 3.975-3.971 3.975zm10.116-8.25h-3.297a8.092 8.092 0 00-6.82-3.75 8.092 8.092 0 00-6.818 3.75H60.795V47.25h36.043l-.075 32.175z"
});

function SvgTruckinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 101 92"
  }, props), _ref, _ref2);
}

export default SvgTruckinline;